import {Storable} from '../interfaces/storable';
import {RouteDTO} from '../dto/route-dto';
import {RouteType} from '../enums/route-type';
import {ImageConversions} from './image-conversions';

export class Route extends Storable<RouteDTO> {
  private readonly _id: number;
  private readonly _slug: string;
  private readonly _name: string;
  private readonly _description: string | null;
  private readonly _latitude: string;
  private readonly _longitude: string;
  private readonly _distanceKm: string;
  private readonly _estimatedDuration: number;
  private readonly _type: RouteType;
  private readonly _image: ImageConversions;
  private readonly _pointOfInterestIds: number[];
  private readonly _storyIds: number[];

  constructor(data: RouteDTO) {
    super();
    this._id = data.id;
    this._slug = data.slug;
    this._name = data.name;
    this._description = data.description;
    this._latitude = data.latitude;
    this._longitude = data.longitude;
    this._distanceKm = data.distance_km;
    this._estimatedDuration = data.estimated_duration;
    this._type = data.type;
    this._image = new ImageConversions(data.image);
    this._pointOfInterestIds = data.point_of_interest_ids;
    this._storyIds = data.story_ids;
  }

  get id(): number {
    return this._id;
  }

  get slug(): string {
    return this._slug;
  }

  get name(): string {
    return this._name;
  }

  get description(): string | null {
    return this._description;
  }

  get latitude(): string {
    return this._latitude;
  }

  get longitude(): string {
    return this._longitude;
  }

  get distanceKm(): string {
    return this._distanceKm;
  }

  get estimatedDuration(): number {
    return this._estimatedDuration;
  }

  get type(): RouteType {
    return this._type;
  }

  get image(): ImageConversions {
    return this._image;
  }

  get pointOfInterestIds(): number[] {
    return this._pointOfInterestIds;
  }

  get storyIds(): number[] {
    return this._storyIds;
  }

  get googleMapsLatLngLiteral(): google.maps.LatLngLiteral {
    return {
      lat: Number(this._latitude),
      lng: Number(this._longitude),
    };
  }

  getDTO(): RouteDTO {
    return {
      id: this._id,
      slug: this._slug,
      name: this._name,
      description: this._description,
      latitude: this._latitude,
      longitude: this._longitude,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      distance_km: this._distanceKm,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      estimated_duration: this._estimatedDuration,
      type: this._type,
      image: this._image.getDTO(),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      point_of_interest_ids: this._pointOfInterestIds,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      story_ids: this._storyIds,
    };
  }
}